import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

import { getActionList } from '../actions';

export default createAsyncReducer<any, GenericResponse>(getActionList);
